import styled from "styled-components";
import { useDispatch,useSelector } from 'react-redux'
import { useState,useEffect} from "react";
import { themeModules } from "../../../theme/theme.js"
import CancelIcon from '@mui/icons-material/Cancel';
import api from '../../../axios.js'
import AutoSelect from '../autoSelect.jsx';
import { juegoSelected } from '../../../redux/actions/juegoActions.js';
import { estadoCuenta,consolaCuenta } from "../../../redux/actions/cuentasActions.js";
import SelectConsolaCuenta  from "./selectConsolaCuenta.jsx"
import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';
import mando from "../../../imgs/mando.svg"
import Card from "../../juegos/card.jsx"


const Container=styled.div`
	
	width:100%;
	height:100%;
	position: absolute;	
	z-index:5;
	display:flex;
	align-items:center;
	justify-content:center;
`;

const Backdrop=styled.div`
	background-color:${themeModules.background};
	width:100%;
	height:100%;
	position: absolute;
	opacity:0.8

`;

const BackdropGame=styled.div`
	width:100%;
	height:100%;
	position: absolute;
	opacity:0.3;
	z-index:0;
`;

const InfoCuenta=styled.div`
	height:10%;
	display:flex;
	align-items:center;
	width:90%;
	font-size:18px;
	margin:10px;
	justify-content:space-between;
`;

const Container2=styled.div`
	z-index:6;
	background-color:${themeModules.panel};
	height:80%;
	width:89%;
	min-width:950px;
	border-radius:8px;
	display:flex;
	flex-direction:column;
	align-items:center;
	justify-content:space-evenly

`;

const Container3=styled.div`
	display:flex;
	width:95%;
	height:80%
`;

const ContainreInfoJuegos=styled.div`
	width:50%;
	display:flex;
	flex-direction:column;
	align-items:center;
	border-right:1px solid grey
`;

const InfoJuegos=styled.div`
	display:flex;
	width:100%;
	height:100%;
	flex-wrap:wrap;
	justify-content:space-evenly
`;

const Title=styled.div`
	width:100%;
	display:flex;
	justify-content:start;
	margin:10px
`;

const RowJuego=styled.div`
	display:flex;
	justify-content:center;
	align-items:center;
	width:160px;
	height:100px;
	margin:3px;
	background-color:${themeModules.background};
	height:120px;
	width:180px;
	border-radius:3px;
	font-size:13px;
	position:relative;
	overflow:hidden
`;

const DesriptionGame=styled.div`
	z-index:1;
	height:90%;
	width:90%;
	display:flex;
	flex-direction:column;
	justify-content:center

`;

const ContainerButton = styled.div`
	display:flex;
	justify-content:center;
	align-items:center;
`;

const Close=styled.div`
	position:absolute;
	top:3vh;
	right:4vw;
	width:35px;
	font-size: 40px;
	&:hover{
	 	cursor:pointer
	 }
`;



const DetailAddGame=styled.div`
	display:flex;
	flex-direction:column;
	width:50%;
	border-left:1px solid grey
`;

const Correo=styled.div`
	margin-left:8px;
	display:flex;
	align-items:center;
	justify-content:center
`;

const ContainerAutoSelect=styled.div`
	width:100%;
	flex-direction:column;
	display:flex;
	justify-content:center;
	align-items:center;
	border-radius:10px	
 `;
 const ContainerConsolas=styled.div`
	width:100%;
	height:100%;
	display:flex;
	flex-direction:column;
	justify-content:center;
	border-radius:10px	;
	align-items:center
 `;

export default function AddGame(props){
	let {cuentas,setAddGame,addGame} = props;
	let [juegosName,setJuegosName]=useState();
	let estado=useSelector(state=>state.cuentas.estadoCuenta);
	let consola=useSelector(state=>state.cuentas.Consolas);
	let juegos=useSelector(state=>state.juego.juegos);
	let juegoSelectedRedux=useSelector(state=>state.juego.juegoSelected);
	const [loading,setLoading]=useState(false);
	let dispatch=useDispatch();

	useEffect(()=>{
 		if(estado===0){
 	 			let nombres=[];
 	 			juegos.map(ele=>ele.activo?nombres.push({label:`${ele.nombre}`,value:ele}):null) 	 	
 	 			setJuegosName(nombres);	
 		}
 	},[juegos,estado])


	let close=()=>{
		setAddGame({...addGame,status:false})
	}

	let cuentaSelected=cuentas.find(cuenta=>cuenta.id===addGame.id);
	

	let save=async()=>{
			if(consola&&juegoSelectedRedux.id){
				if(window.confirm("Desea asignar este juego a la cuenta?")){
					dispatch(estadoCuenta(1));
					setLoading(true);
					try{
						await api.post(`/cuenta/addGame?idAcount=${cuentaSelected.id}&idGame=${juegoSelectedRedux.id}&consola=${consola}`);
						alert("Juego asignado correctamente");
						close()
					}catch(err){console.log(err);alert("error al grabar los datos")}
					setLoading(false);
					dispatch(estadoCuenta(0));
				}		
			}else{
				alert("datos incompletos")
			}
	}

	
	return (
		<Container>
			<Backdrop/>
			<Container2>
				<Close onClick={close}><CancelIcon fontSize="50px"/></Close>
				<InfoCuenta>
					<div style={{display:"flex"}}>
						<div>agregar juego a cuenta :</div><Correo><b> {cuentaSelected.correo}</b></Correo>
					</div>
					<ContainerButton>
						<LoadingButton loading={loading} startIcon={<SaveIcon />} variant="outlined"   onClick={save}> Save </LoadingButton >
					</ContainerButton>
				</InfoCuenta>
				<Container3>
				<ContainreInfoJuegos>
					<Title>
						Juegos Registrados						
					</Title>
					<InfoJuegos>
						{cuentaSelected.juegos?cuentaSelected.juegos.map(juego=>{
							return(
								<RowJuego>
									<BackdropGame>
										<Card  consola={juego.consola}poster={juego.poster}/>
									</BackdropGame>
									<DesriptionGame>
										<div><img src={mando} style={{marginRight:"8px"}} alt="mando de play" /></div>
										<div><label>juego :</label>{juego.nombre}</div>
										<div><label>consola :</label>{juego.consola}</div>
									</DesriptionGame>
								</RowJuego>)
						}):null}				
					</InfoJuegos>					
				</ContainreInfoJuegos>					 
				<DetailAddGame> 
					<ContainerAutoSelect>
						<InfoCuenta>
 							Juegos Disponibles
 						</InfoCuenta>
 						<AutoSelect data={juegosName}  id="juegos"  label="juegos"  disabled={estado!==0?true:false} action={juegoSelected} />
 					</ContainerAutoSelect>
 					<ContainerConsolas>
 						<InfoCuenta>
 							Consolas Disponibles
 						</InfoCuenta>
 						<SelectConsolaCuenta consolasId={juegoSelectedRedux.Consolas} action={consolaCuenta} estado={0}/> 
 					</ContainerConsolas>		
				</DetailAddGame>
				</Container3>
			</Container2>
			
		</Container>
			
		)
}